import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7105c446"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "icon"
};
const _hoisted_3 = {
  class: "right"
};
const _hoisted_4 = {
  class: "time"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, "|", -1));
const _hoisted_6 = {
  class: "wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Expand = _resolveComponent("Expand");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Fold = _resolveComponent("Fold");
  const _component_SwitchButton = _resolveComponent("SwitchButton");
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.isClose ? (_openBlock(), _createBlock(_component_el_icon, {
    key: 0,
    onClick: $setup.change
  }, {
    default: _withCtx(() => [_createVNode(_component_Expand)]),
    _: 1
  }, 8, ["onClick"])) : (_openBlock(), _createBlock(_component_el_icon, {
    key: 1,
    onClick: $setup.change
  }, {
    default: _withCtx(() => [_createVNode(_component_Fold)]),
    _: 1
  }, 8, ["onClick"]))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString($setup.time), 1), _hoisted_5, _createElementVNode("div", {
    class: "loginout",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.out && $setup.out(...args))
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_SwitchButton)]),
    _: 1
  })])])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_router_view)])], 64);
}